import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { apiRequest } from '../api';
import { useTranslation } from 'react-i18next';
import API_BASE_URL from '../apiConfig';
import { welcomeAssets } from './assetImports';
import './WelcomeScreen.css';

const WelcomeScreen = ({ isTelegramMiniApp, referrerId  }) => {
  const { user, updateUser } = useContext(AuthContext);
  const [currentPage, setCurrentPage] = useState(0);
  const navigate = useNavigate();
  const { t } = useTranslation('welcome');
  const getTextKey = (baseKey) => isTelegramMiniApp ? baseKey : `${baseKey}_web`;

  
  const welcomeContent = [
    {
      image: welcomeAssets.welcome1,
      title: t(`page1.${getTextKey('title')}`),
      subtitle: t(`page1.${getTextKey('subtitle')}`),
    },
    {
      image: welcomeAssets.welcome2,
      title: t(`page2.${getTextKey('title')}`),
      subtitle: t(`page2.${getTextKey('subtitle')}`),
    },
    {
      image: welcomeAssets.welcome3,
      title: t(`page3.${getTextKey('title')}`),
      subtitle: t(`page3.${getTextKey('subtitle')}`),
    },
    {
      image: welcomeAssets.welcome4,
      title: t(`page4.${getTextKey('title')}`),
      subtitle: t(`page4.${getTextKey('subtitle')}`),
    },
    {
      image: welcomeAssets.welcome5,
      title: t(`page5.${getTextKey('title')}`),
      subtitle: t(`page5.${getTextKey('subtitle')}`),
    },
  ];

  useEffect(() => {
    const markWelcomeSeen = async () => {
      try {
        await apiRequest(
          `${API_BASE_URL}/api/users/complete-welcome`,
          {
            method: 'POST',
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ initialBalance: 500 }),
          }
        );

        updateUser({ 
          ...user, 
          hasSeenWelcomeScreens: true,
          wallets: {
            ...user.wallets,
            token: 500
          }
        });
      } catch (error) {
        console.error('Error completing welcome flow:', error);
      }
    };

    if (!user?.hasSeenWelcomeScreens) {
      markWelcomeSeen();
    }
  }, [user, updateUser]);

  const handleNext = () => {
    if (currentPage < welcomeContent.length - 1) {
      setCurrentPage(currentPage + 1);
    } else {
      if (referrerId) {
      navigate(`/game?referrerId=${referrerId}`);
    } else {
      navigate('/game');
    }
    }
  };

  return (
    <div className="welcome-page-container">

      <div className="welcome-image-container">
        <img 
          src={welcomeContent[currentPage].image} 
          alt="Welcome illustration"
          className="welcome-image"
        />
      </div>


      <div className="welcome-content-container">
        <div className="welcome-text-group">

      {currentPage === 0 ? (
        <>
        <p className="welcome-subtitle">{welcomeContent[currentPage].subtitle}</p>
        <h1 className="welcome-title">{welcomeContent[currentPage].title}</h1>
        </>
        ) : (
        <>
          <h1 className="welcome-title">{welcomeContent[currentPage].title}</h1>
          <p className="welcome-subtitle">{welcomeContent[currentPage].subtitle}</p>
        </>
        )}
        </div>

       <button
  onClick={handleNext}
  className={`welcome-next-button ${currentPage === welcomeContent.length - 1 ? 'play-button' : ''}`}
>
  <span className="welcome-button-content">
    {currentPage === welcomeContent.length - 1 ? t('play') : t('next')}
  </span>
</button>


        <div className="welcome-indicators-container">
          <div className="welcome-indicators">
            {welcomeContent.map((_, index) => (
              <div
                key={index}
                className={`welcome-indicator ${index === currentPage ? 'active' : ''}`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeScreen;